(function(){
  var root = document.querySelector('.dpc-pr');
  if (!root) return;

  var main = root.querySelector('[data-dpc-main]');
  root.querySelectorAll('[data-dpc-thumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (main) main.src = btn.dataset.dpcThumb;
      root.querySelectorAll('[data-dpc-thumb]').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  root.querySelectorAll('[data-dpc-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = root.querySelector('[data-dpc-qty-input]');
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.dpcQty, 10);
      input.value = next < 1 ? 1 : next;
    });
  });

  var dataEl = document.querySelector('[data-dpc-variant-data]');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var idInput = root.querySelector('[data-dpc-variant-id]');
  var priceBox = root.querySelector('.dpc-buy__price');
  var submit = root.querySelector('[data-dpc-submit]');
  var submitText = root.querySelector('[data-dpc-submit-text]');
  var skuEl = root.querySelector('[data-dpc-sku]');
  var ADD = 'Añadir al carrito';
  var ADDED = 'Añadido al carrito';
  var NOSTOCK = 'Sin stock, consultar plazo';
  var IVA = 'Precio sin IVA · se añade 21% de IVA en el pago';

  function selected(){
    var out = [];
    root.querySelectorAll('[data-dpc-opt]:checked').forEach(function(i){ out[parseInt(i.dataset.dpcOpt,10)] = i.value; });
    return out;
  }
  function match(opts){
    return variants.find(function(v){
      return v.options.every(function(o, i){ return o === opts[i]; });
    });
  }
  function paint(v){
    if (!v) return;
    if (idInput) idInput.value = v.id;
    if (priceBox) {
      var html = '<div class="price"><div class="price__container">';
      if (v.hasCompare > 0) html += '<s>' + v.compare + '</s>';
      html += '<span class="price-item price-item--regular">' + v.price + '</span>';
      html += '</div></div><div class="dpc-iva-note" style="margin-top:8px;font-size:.85rem;color:rgba(14,17,22,.7);">' + IVA + '</div>';
      priceBox.innerHTML = html;
    }
    if (submit) submit.disabled = !v.available;
    if (submitText) submitText.textContent = v.available ? ADD : NOSTOCK;
    if (skuEl && v.sku) skuEl.textContent = v.sku;
    if (v.image && main) main.src = v.image;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
    root.querySelectorAll('[data-dpc-opt]').forEach(function(input){
      var idx = parseInt(input.dataset.dpcOpt, 10);
      var test = selected().slice();
      test[idx] = input.value;
      var found = variants.find(function(c){ return c.options.every(function(o,i){ return o === test[i]; }); });
      input.disabled = !found;
    });
    root.querySelectorAll('[data-dpc-optvalue]').forEach(function(el){
      var i = parseInt(el.dataset.dpcOptvalue, 10);
      el.textContent = v.options[i] || '';
    });
  }
  root.querySelectorAll('[data-dpc-opt]').forEach(function(input){
    input.addEventListener('change', function(){ paint(match(selected())); });
  });

  var form = document.getElementById('dpc-product-form');
  if (form) {
    form.addEventListener('submit', function(e){
      if (!window.fetch) return;
      e.preventDefault();
      var qty = root.querySelector('[data-dpc-qty-input]').value || 1;
      submit.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: idInput.value, quantity: parseInt(qty, 10) }] })
      }).then(function(r){ return r.json(); }).then(function(){
        if (submitText) submitText.textContent = ADDED;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          fetch(window.location.pathname + '?section_id=cart-drawer').then(function(r){ return r.text(); }).then(function(html){
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
            if (fresh) { drawer.innerHTML = fresh.innerHTML; drawer.classList.remove('is-empty'); }
            drawer.open(submit);
          });
        } else {
          window.location.href = '/cart';
        }
      }).catch(function(){ form.submit(); })
      .finally(function(){
        submit.disabled = false;
        setTimeout(function(){ if (submitText) submitText.textContent = ADD; }, 2500);
      });
    });
  }
})();